import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';

const CommentSubmissionForm = ({ onActionClick }) => {
  return (
    <section className="mt-16 md:mt-20">
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-8 text-center">Leave a Comment</h2>
      <form className="max-w-2xl mx-auto bg-card p-6 sm:p-8 rounded-xl shadow-xl space-y-6">
        <div>
          <label htmlFor="commentName" className="block text-sm font-medium text-muted-foreground mb-1">Name</label>
          <Input type="text" id="commentName" name="commentName" placeholder="Your Name" className="bg-background/70 border-border focus:border-primary" aria-label="Your name for comment"/>
        </div>
        <div>
          <label htmlFor="commentEmail" className="block text-sm font-medium text-muted-foreground mb-1">Email (optional, not published)</label>
          <Input type="email" id="commentEmail" name="commentEmail" placeholder="you@example.com" className="bg-background/70 border-border focus:border-primary" aria-label="Your email for comment (optional)"/>
        </div>
        <div>
          <label htmlFor="commentText" className="block text-sm font-medium text-muted-foreground mb-1">Comment</label>
          <Textarea id="commentText" name="commentText" rows="4" placeholder="Write your thoughts..." className="bg-background/70 border-border focus:border-primary" aria-label="Your comment text"></Textarea>
        </div>
        <Button type="button" onClick={() => onActionClick("Submit Comment")} className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground font-semibold shadow-md hover:shadow-primary/30 transition-all">
          Submit Comment
        </Button>
      </form>
    </section>
  );
};

export default CommentSubmissionForm;